import React, { ReactNode } from 'react';
import { PanelWrapper, PanelHeader } from './styled';
import { CloseButton } from '../../ui/PageHeader/CloseButton';

interface MapSidePanelProps {
  onClose: () => void;
  isFullScreen: boolean;
  children: ReactNode;
}

export const MapSidePanel: React.FC<MapSidePanelProps> = ({
  onClose,
  isFullScreen,
  children
}) => (
  <PanelWrapper $isFullScreen={isFullScreen}>
    <PanelHeader>
      <CloseButton onClick={onClose} />
    </PanelHeader>

    {children}
  </PanelWrapper>
);
